// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/GenRedOne/assets/css/common.css
// module id = RtzP
// module chunks = 29